/* eslint-disable no-extend-native */
// eslint-disable-next-line no-restricted-globals
/**
 * Validation Error
 *
 * Example:
 *   {
 *       key: 'validations.stringMin',
 *       args: {
 *           min: 2
 *       }
 *   }
 *
 * Assume that the key maps into the following tokenized error message
 *   Must be at least {{min}} characters
 *
 * Then the final error message will be
 *   Must be at least 2 characters
 */

import type { Translate } from "next-translate";

type LocalizationMessage =
  | string
  | {
      key: string;
      args?: Record<string, unknown>;
    }
  | undefined;

String.prototype.handleLocalizationText = (message: LocalizationMessage, t: Translate): string => {
  if (message === undefined) {
    return "";
  }

  if (typeof message === "string") {
    return message;
  }

  // handle yup validation error obj!
  const { key, args } = message;

  return t(key, { ...args });
};
